import { Attrs, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import { Routing } from '../../modules/routing'
Locale.getInstance().registerKeySet('en', 'lvcNoResults', {
  primaryTitle: 'No results found!',
  secondaryTitle: 'Try another location or visit our search page for more options.',
  secondaryTitleSearch: "Try another search with different filters—you're sure to find something!",
  link: {
    text: 'Go to search page',
    url: `${Routing.ROUTES['search']}`,
  },
})
Locale.getInstance().registerKeySet('fr', 'lvcNoResults', {
  primaryTitle: 'Aucun résultat trouvé&nbsp!',
  secondaryTitle:
    "Essayez un autre emplacement ou rendez-vous sur notre page de recherche pour plus d'options.",
  secondaryTitleSearch:
    'Essayez une autre recherche avec des filtres différents, je suis sûr que vous trouverez quelque chose&nbsp!',
  link: {
    text: 'Aller à la recherche',
    url: `${Routing.ROUTES[Locale.language].searchResults}`,
  },
})

export class LvcNoResults extends MinzeElement {
  attrs: Attrs = [['data-is-search', false]]
  html = () => `
    <div class="lvc-no-results__text-wrapper">
      <div class="lvc-no-results__primary-title">${Locale.getKey('lvcNoResults.primaryTitle')}</div>
      ${
        this.dataIsSearch
          ? `<div class="lvc-no-results__secondary-title">${Locale.getKey('lvcNoResults.secondaryTitleSearch')}</div>`
          : `<div class="lvc-no-results__secondary-title">${Locale.getKey('lvcNoResults.secondaryTitle')}</div>`
      }
      ${this.dataIsSearch ? '' : `<a class="lvc-no-results__button" href="${Locale.getKey('lvcNoResults.link.url')}">${Locale.getKey('lvcNoResults.link.text')}</a>`}
    </div>
    <div>
      <lvc-sad-charlie-face-icon data-fill="#1E007D"></lvc-sad-charlie-face-icon>
    </div>
`
  css = () => `
    :host {
      display: flex;
      align-items: center;
      padding-top: 2rem;
      padding-bottom: 2rem;
      padding-left: 2rem;
      padding-right: 2rem;
      gap: 5rem;
      width: 100%;
    }
    .lvc-no-results__primary-title {
      line-height: 1.1;
      font-size: 3rem;
      font-weight: 800;
      margin-bottom: 1rem;
    }
    .lvc-no-results__secondary-title {
      font-size: 1.25rem;
      margin-bottom: ${this.dataIsSearch ? '0' : '4rem'};
    }
    .lvc-no-results__button {
      font-size: 1.25rem;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 999px;
      background-color: #1E007D;
      text-decoration: none;
    }
    lvc-sad-charlie-face-icon::part(svg) {
      color: #1E007D;
      width: 150px;
      height: 150px;
      fill: #1E007D;
    }
    @media screen and (max-width: 991px) {
      :host {
        flex-direction: column;
        gap: 2rem;
        padding-left: 1rem;
        padding-right: 1rem;
        text-align: center;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
        width:100%;
      }
      .lvc-no-results__primary-title {
        font-size: 2.5rem;
      }
      .lvc-no-results__secondary-title {
        font-size: 1rem;
      }
      .lvc-no-results__button {
        font-size: 1rem;
      }
      lvc-sad-charlie-face-icon::part(svg) {
        width: 100px;
        height: 100px;
      }
    }
  `
}
